// extracted by mini-css-extract-plugin
export default {"modalOverlay":"AuthModal_modalOverlay__gdFYB","modalContent":"AuthModal_modalContent__tiG2T"};